import Handler from "../Handler";

class WaitListFailureHandler extends Handler {
  execute(message) {
    // WaitF#
    this.service.processWaitListFailure();
  }
}

export default WaitListFailureHandler;